module.exports = __webpack_public_path__ + "img/alienware-laptop.1bccaa4e.jpg";